import type { LucideIcon } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export type QuickAction = {
  label: string;
  href: string;
  icon: LucideIcon;
};

export type DashboardQuickActionsProps = {
  actions: QuickAction[];
};

export function DashboardQuickActions({ actions }: DashboardQuickActionsProps) {
  return (
    <Card data-testid="card-quick-actions">
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {actions.map(action => {
          const Icon = action.icon;
          return (
            <a
              key={action.label}
              href={action.href}
              className="p-3 rounded-md border hover-elevate transition-colors flex items-center gap-3"
              data-testid={`link-${action.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <Icon className="w-4 h-4 text-muted-foreground shrink-0" />
              <span className="text-sm font-medium">{action.label}</span>
            </a>
          );
        })}
      </CardContent>
    </Card>
  );
}

export default DashboardQuickActions;
